/**
 *
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const validMaps = ['admin', 'editor'];
  return validMaps.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  // eslint-disable-next-line max-len
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  // eslint-disable-next-line no-useless-escape
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }
  return Array.isArray(arg);
}


const rules = i18n => ({

  login: {
    username: [{
        required: true,
        message: i18n.t('lang.validate.login.accountrequired'),
        trigger: 'blur',
      },
      {
        type: 'string',
        min: 4,
        message: i18n.t('lang.validate.login.accountlengthgreaterthanfour'),
        trigger: 'blur',
      },
    ],
    password: [{
        required: true,
        message: i18n.t('lang.validate.login.passwordrequired'),
        trigger: 'blur',
      },
      {
        type: 'string',
        min: 4,
        message: i18n.t('lang.validate.login.passwordlengthgreaterthansix'),
        trigger: 'blur',
      },
    ],
  },
  user: {
    userName: [{
        required: true,
        message: i18n.t('lang.validate.user.accountrequired'),
        trigger: 'blur',
      },
      // {
      //     type: "string",
      //     min: 4,
      //     message: i18n.t('lang.validate.user.accountlengthgreaterthanfour'),
      //     trigger: "blur",
      // },
    ],
    password: [{
        required: true,
        message: i18n.t('lang.validate.user.passwordrequired'),
        trigger: 'blur',
      },
      {
        type: 'string',
        min: 6,
        message: i18n.t('lang.validate.user.passwordlengthgreaterthansix'),
        trigger: 'blur',
      },
    ],
  },

});

export default rules;



// WEBPACK FOOTER //
// ./src/utils/validate.js